export default {
    createBehavior_newMetric: "Create New Metric",
    createBehavior_editMetric: "Edit Metric For",
    createBehavior_selectAMetricOption: 'Please select a metric option',
    createBehavior_createMetric_success: 'Metric Created Successfully',
    createBehavior_updateMetric_success: 'Metric Updated Successfully',
    createBehavior_metricValueRequired: 'Metric Values is required',
    behavior_metricHasAlready: 'This metric has already been created.',
}
